export default {
    locale: 'es-ES',
    dismissAlertText: 'Cerrar'
};
